import {useEffect, useState} from 'react';
import styles from './ReportListView.module.css';
import {IReportAction, TableRow} from "../../types/types.table.ts";
import {postUser} from "../../helper/http.ts";

interface AppBarProps {
  action: IReportAction;
  row: TableRow;
}

export default function ReportListView({
    action,
    row
}: AppBarProps) {
    const [page, setPage] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {


      const body: any = {
          module: action.module,
          page: page.toString(),
          per_page: "10",
          sort_direction: "+",
          sort_field: "id",
          filters: {},
      };

      for (let key in action.params) {
          body.filters[key] = row[action.params[key]];
      }

        postUser("crud/list", body).then((res) => {

            setData(res.data);

            setLoading(false);
        });

    }, [page]);

    if (loading) return <div>loading...</div>

    if (data.length === 0) return <div>No items found</div>;

    return <table className={styles.prettyTable}>
        <thead>
        {(action.fields || Object.keys(data[0])).map(item => <th>{item}</th>)}
        </thead>
        <tbody>
        {data.map(row => <tr>
            {(action.fields || Object.keys(data[0])).map(item => <td>{row[item]}</td>)}
        </tr>)}
        </tbody>
    </table>
}